<template>
  <div class="mt-3">
    <div class="header-purple">
      <div class="d-flex justify-content-between">
        <p class="mb-0 mt-2">
          <strong>รายการเปลี่ยน</strong>
        </p>
        <b-button
          @click="$refs.addProductModal.openModal()"
          v-if="isExchangeable"
          class="btn-main ml-2 h-100"
        >
          <span>เพิ่มสินค้า </span>
        </b-button>
      </div>
    </div>
    <div class="bg-white">
      <b-container class="p-0">
        <b-table
          responsive
          :thead-tr-class="thTableProduct"
          :tbody-tr-class="trTableProduct"
          class="text-center"
          :fields="fields"
          :items="productDetailList"
          :busy="isBusy"
          show-empty
          empty-text="ไม่พบข้อมูล"
        >
          <template v-slot:head(id)="">
            <b-form-checkbox
              size="lg"
              class="ml-3"
              id="order-time-cb-all"
              name="orderTimeCbAll"
              @change="checkOrderHeader"
            ></b-form-checkbox>
          </template>
          <template v-slot:head(imageUrl)="">
            <div class="border-right">
              <strong>ภาพสินค้า</strong>
            </div> </template
          ><template v-slot:head(sku)="">
            <div class="border-right">
              <strong>SKU</strong>
            </div> </template
          ><template v-slot:head(name)="">
            <div class="border-right">
              <strong>ชื่อสินค้า</strong>
            </div> </template
          ><template v-slot:head(productQty)="">
            <div class="border-right">
              <strong>จำนวนชิ้น</strong>
            </div> </template
          ><template v-slot:head(price)="">
            <div class="border-right">
              <strong>ราคาต่อหน่วย</strong>
            </div>
          </template>
          <template v-slot:cell(id)="data">
            <b-form-checkbox
              size="lg"
              class="ml-3"
              :value="data.item.sku"
              v-model="productSelectList"
            ></b-form-checkbox>
          </template>
          <template v-slot:cell(imageUrl)="data">
            <div>
              <div
                v-if="data.item.imageUrl"
                class="table-image"
                v-bind:style="{
                  'background-image': 'url(' + data.item.imageUrl + ')',
                }"
              ></div>
              <div v-else>-</div>
            </div>
          </template>
          <template v-slot:cell(sku)="data">
            <div v-if="data.item.sku" class="text-table">
              <p class="m-0">{{ data.item.sku }}</p>
            </div>
            <div v-else><p class="m-0">-</p></div>
          </template>
          <template v-slot:cell(name)="data">
            <div v-if="data.item.name" class="text-left text-table">
              <p class="m-0">{{ data.item.name }}</p>
              <span v-if="data.item.promotion">
                <b-badge pill variant="Info" class="px-3 py-2 GWP mt-1">{{
                  data.item.promotion
                }}</b-badge
                ><br />
              </span>
              <span class="text-danger" v-if="data.item.isFree == 1"
                >(ฟรี)</span
              >
            </div>
            <div v-else><p class="m-0">-</p></div>
          </template>
          <template v-slot:cell(productQty)="">
            <div class="stock-text">
              <p class="m-0">{{ 1 | numeral("0,0") }}</p>
            </div>
          </template>
          <template v-slot:cell(price)="data">
            <p class="m-0 price-text" v-if="data.item.price">
              ฿ {{ data.item.price | numeral("0,0.00") }}
            </p>
            <p v-else class="m-0 price-text">-</p>
          </template>
          <template v-slot:cell(total)="data">
            <div class="custom-input">
              <InputText
                :value="data.item.newPrice"
                placeholder="0"
                type="number"
                name="newPrice"
                :isValidate="
                  $v.productDetailList.$each.$iter[data.index].newPrice.$error
                "
                isRequired
                :v="$v.productDetailList.$each.$iter[data.index].newPrice"
                @input="(val) => (data.item.newPrice = val)"
              />
            </div>
          </template>
          <template v-slot:cell(deleteProduct)="data">
            <b-button
              variant="link"
              class="text-danger px-1 py-0"
              @click="deleteProduct(data.index)"
            >
              <font-awesome-icon icon="trash-alt" title="Delete" />
            </b-button>
          </template>
        </b-table>
      </b-container>
      <div>
        <p v-if="totalSummary > summary" class="text-error pl-3">* ราคารวมสุทธิห้ามน้อยกว่า ฿ {{ totalSummary | numeral("0,0.00") }}</p>
      </div>
      <AddProductModal
        ref="addProductModal"
        @add-product="addProduct"
        :listId="listAllDataId"
        name="addProductModal"
      />
      <!-- <ModalAlertConfirm
        :msg="titleModal"
        :text="detailModal"
        btnConfirm="ตกลง"
        btnCancel="ยกเลิก"
        ref="isModalAlertConfirm"
        @confirm="acceptAction"
      /> -->
    </div>
  </div>
</template>

<script>
import { BIcon } from "bootstrap-vue";
import AddProductModal from "./../modal/AddProductModal.vue";
import InputText from "@/components/inputs/InputText";
import { required, minValue, integer } from "vuelidate/lib/validators";
// import ModalAlertConfirm from "@/components/modal/alert/ModalAlertConfirm";
const validateMinPrice = (value, minPrice) => {
  if (value < minPrice) {
    return false;
  } else {
    return true;
  }
};

export default {
  name: "OrderDetailPanel",
  components: { BIcon, AddProductModal, InputText },
  props: {
    orderStatus: {
      type: [String, Number],
      isRequired: true,
    },
    orderProductDetail: {
      type: Array,
      isRequired: true,
    },
    orderProductPriceDetail: {
      type: Object,
      isRequired: true,
    },
    productIdList: {
      type: Array,
      isRequired: true,
    },
    isExchangeable: {
      type: Boolean,
      isRequired: false,
    },
    orderId: {
      type: [String, Number],
      isRequired: true,
    },
    isDisplayChange: {
      type: Boolean,
      isRequired: false,
    }
  },
  validations() {
    return {
      productDetailList: {
        $each: {
          newPrice: {
            required,
            integer,
            validateMinPrice: function (newPrice, data) {
              return validateMinPrice(parseFloat(newPrice), parseFloat(data.price) * 1);
            },
          },
        },
      },
    };
  },
  computed: {
    summary() {
      let sum = 0;
      this.productDetailList.forEach(element => {
        sum += parseFloat(element.newPrice);
      });
      return sum
    }
  },
  data() {
    return {
      productDetailList: [],
      fields: [
        {
          key: "imageUrl",
          label: `ภาพสินค้า`,
          class: "text-nowrap",
          thStyle: {
            "padding-left": "0px !important",
            "padding-right": "0px !important",
            width: "15%",
          },
          hold: false,
        },
        {
          key: "sku",
          label: `SKU`,
          class: "text-nowrap",
          thStyle: {
            "padding-left": "0px !important",
            "padding-right": "0px !important",
            width: "20%",
          },
          hold: false,
        },
        {
          key: "name",
          label: `ชื่อสินค้า`,
          class: "text-nowrap",
          thStyle: {
            "padding-left": "0px !important",
            "padding-right": "0px !important",
          },
          hold: false,
        },
        {
          key: "productQty",
          label: `จำนวนชิ้น`,
          class: "text-nowrap",
          thStyle: {
            "padding-left": "0px !important",
            "padding-right": "0px !important",
            width: "10%",
          },
          hold: false,
        },
        {
          key: "price",
          label: `ราคาต่อหน่วย`,
          class: "text-nowrap",
          thStyle: {
            "padding-left": "0px !important",
            "padding-right": "0px !important",
            width: "10%",
          },
          hold: false,
        },
        {
          key: "total",
          label: `ราคาสุทธิ`,
          class: "text-nowrap",
          thStyle: {
            "padding-left": "0px !important",
            "padding-right": "0px !important",
            width: "200px",
          },
          hold: false,
        },
        {
          key: "deleteProduct",
          label: ``,
          class: "text-nowrap",
          thStyle: {
            "padding-left": "0px !important",
            "padding-right": "0px !important",
            width: "40px",
          },
          hold: false,
        },
      ],
      thTableProduct: {
        "border-bottom": "2px solid #f8f8f8 !important",
        "min-height": "80px !important",
      },
      trTableProduct: { "border-bottom": "2px solid #f8f8f8 !important" },
      isBusy: false,
      collapseShipping: true,
      collapseDiscount: true,
      collapseService: true,
      productSelectList: [],
      titleModal: "",
      detailModal: "",
      listAllDataId: [],
      selected: null,
      options: [
        { value: 0, text: "สินค้าปกติ" },
        { value: 1, text: "สินค้าเปลี่ยน" },
      ],
      totalSummary: 0
    };
  },
  methods: {
    setProductDetailList: async function (list) {
      this.totalSummary = 0;
      await list.forEach((element) => {
        this.totalSummary += parseFloat(element.price)*parseInt(element.productQty)
      });
    },
    getProductDetailList: async function () {
      this.$v.productDetailList.$touch();
      if (this.$v.productDetailList.$error) return false;

      if (this.totalSummary > this.summary) return false;

      return this.productDetailList;
    },
    deleteProduct: async function (index) {
      this.productDetailList.splice(index, 1);
    },
    checkTextNull(text) {
      return text ? text : "-";
    },
    changeProductItem(id) {
      console.log(`id`, id);
    },
    changeHistoryProduct(id) {
      console.log(`id`, id);
    },
    checkOrderHeader(value) {
      if (value) {
        this.productSelectList = this.productIdList;
      } else {
        this.productSelectList = [];
      }
    },
    returnProduct() {
      this.$emit("returnProduct", {
        data: productSelectList,
        title: "ยืนยันการคืนสินค้า",
        detail: "ต้องการทำรายการคืนสินค้าหรือไม่",
      });
    },
    saveConfirm() {
      // this.titleModal = "บันทึกรายการ"
      // this.detailModal = "ต้องการบันทึกรายการหรือไม่"
      // this.confirmAction();
    },
    save: async function () {
     
    },
    // confirmAction: function() {
    //   this.$refs.isModalAlertConfirm.show();
    // },
    // acceptAction() {
    //   this.$refs.isModalAlertConfirm.hide();
    // },
    addProduct: async function (productSelected, listIdSelected) {
      await productSelected.forEach((element) => {
        this.productDetailList.push({ ...element, newPrice: element.price });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.header-purple {
  padding: 1rem 1.5rem;
  background: #e0e1f4;
}
.price-text {
  white-space: nowrap;
}
.text-table {
  color: #7e7e7e;
}
.bg-gray {
  color: #333333;
  background-color: #f1f1f1;
  width: 85%;
}
.bg-purple {
  color: #ffffff;
  background-color: #8a44c3;
}
.btn-collapse {
  color: #333333;
}
.text-gray {
  color: #c5c5c5;
}
.text-purple {
  color: #8a44c3;
}
.collapse-shipping {
  margin-top: -5px;
}
.summarize {
  margin-right: -80px;
  width: 60%;
}
.stock-text {
  min-width: 80px;
}
.GWP {
  background-color: #e3e2f2;
  color: #8078c6;
}
.order-btn-link {
  color: #8f20c6;
  font-size: 16px;
  cursor: pointer;
  text-decoration: underline;
}
.custom-input .div-input {
  margin-bottom: 0px;
}
</style>
